import { render, staticRenderFns } from "./PackingTypeEditPopup.vue?vue&type=template&id=46c73dc0&scoped=true"
import script from "./PackingTypeEditPopup.vue?vue&type=script&lang=js"
export * from "./PackingTypeEditPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46c73dc0",
  null
  
)

export default component.exports